import React, { useState, useMemo, useEffect, useLayoutEffect } from 'react'

export default ({
  options = [],
  width,
  itemMinWidth = 120,
  beforeSetOption,
  rowCount = 2,
  columnCount = 3,
  maxColumnCount = 0,
  gridGap = 12,
  style,
  renderCard,
  domRef,
  wrapStyle
}) => {
  const [span, setSpan] = useState(columnCount) // 每行显示的个数
  const [itemWidth, setItemWidth] = useState(itemMinWidth)
  const _itemWidth = itemMinWidth > itemWidth ? itemMinWidth : itemWidth
  const [_options, set_options] = useState(options)
  const itemPadding = useMemo(() => {
    const _padding = itemWidth - itemMinWidth < 16 ? 16 : itemWidth - itemMinWidth
    if (_padding > 24) {
      return 24
    }
    return _padding
  }, [itemWidth])

  useEffect(() => {
    const _temp = options.slice(0, rowCount * span)
    const _slotOption = beforeSetOption?.(_temp, span) || _temp
    set_options(_slotOption)
  }, [options, rowCount, span])

  useLayoutEffect(() => {
    const count = Math.floor(width / itemMinWidth)
    if (count < columnCount) {
      const __itemWidth = width / columnCount
      setItemWidth?.(__itemWidth - gridGap)
      setSpan(columnCount)
    } else if (count < maxColumnCount || !maxColumnCount) {
      const __itemWidth = width / count
      setItemWidth?.(__itemWidth - gridGap)
      setSpan(count)
    } else {
      const __itemWidth = width / maxColumnCount
      setItemWidth?.(__itemWidth - gridGap)
      setSpan(maxColumnCount)
    }
  }, [width])

  return <div ref={domRef} style={wrapStyle}>
    <div style={{ display: 'grid', gridGap, gridTemplateColumns: `repeat(${span}, 1fr)`, ...style }}>
      {_options.map(dataItem => renderCard({
        data: dataItem,
        itemPadding,
        style: {
          width: _itemWidth,
        },
        innerWidth: _itemWidth - itemPadding }))}
    </div>
  </div>
}
